<template>
  <el-table :data="tableData"
            stripe
            style="width: 100%">
    <el-table-column align="center"
                     prop="name"
                     label="姓名">
    </el-table-column>
    <el-table-column align="center"
                     prop="mobile"
                     label="电话">
    </el-table-column>
    <el-table-column align="center"
                     prop="email"
                     label="电子邮箱">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  data () {
    return {
      tableData: [{
        name: '徐科',
        mobile: '13789489016',
        email: '1037148022@qq.com'
      }, {
        name: '张旭',
        mobile: '16604731667',
        email: '1311233155@qq.com'
      }, {
        name: '崔浩',
        mobile: '15164880142',
        email: '1837453473@qq.com'
      }, {
        name: '郭佳怡',
        mobile: '13224803150',
        email: 'gjy459gy@163.com'
      }, {
        name: '王文宇',
        mobile: '15540189913',
        email: '1037148022@qq.com'
      }
      ]
    }
  }
}
</script>
<style scoped>
.el-table {
  border-radius: 15px;
}
</style>
